import { EOLocale } from 'eo-locale';
import React, { Fragment } from 'react';
import Image from '@react/shared/Image';
const specialCharacters = ['!', '?', ':', ';'];
const BlogCard = ({ title, image, url, authorName, authorImage, date, readTime, pinText, }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card card--blog", "data-aos": "animated" },
        React.createElement("div", { className: "card__inner" },
            React.createElement("div", { className: "card__media" },
                React.createElement("div", { className: "card__media-holder" },
                    React.createElement(Image, { image: image, alt: title, width: 690, className: "card__media-element", cdn: true }))),
            React.createElement("div", { className: "card__content-external" },
                React.createElement("div", { className: "tag tag--blue" }, pinText),
                React.createElement("div", { className: "card__content-internal" },
                    React.createElement("p", { className: "card__blog-detail" }, readTime > 0 && (React.createElement(Fragment, null,
                        React.createElement(EOLocale.Text, { id: "xperience.readtime", readTime: readTime }),
                        React.createElement("span", { className: "card__date" },
                            React.createElement("span", { className: "bullet" }, "\u2022"),
                            new Intl.DateTimeFormat(undefined, {
                                year: 'numeric',
                                month: 'short',
                                day: '2-digit',
                            }).format(new Date(date)))))),
                    React.createElement("h4", { className: 'card__title ' +
                            (specialCharacters.includes(title.substring(title.length - 1, title.length))
                                ? 'no-full-stop'
                                : '') }, title.trim().replace(/[.$]/, '')),
                    React.createElement("div", { className: "card__author" },
                        authorImage && (React.createElement("div", { className: "card__author-img" },
                            React.createElement(Image, { image: authorImage, alt: authorName, ratio: 1, width: 32, className: "card__author-element", cdn: true, loading: "lazy" }))),
                        authorName && React.createElement("span", { className: "card__author-name" }, authorName))))))));
export default BlogCard;
